/* eslint-disable no-undef */
export default Object.freeze({
  API_URL: env.API_URL,
  HASH: env.COMMIT,
  BRANCH: env.BRANCH,

  ENVIRONMENT: env.ENVIRONMENT,
});
